import { LabelResolver } from "@ax/office-resources-common";
import { LabelLoader, PowerAppsLabelLoader } from "./localization/LabelLoader";
import * as resourcesModule from "./localization/Resources";
import * as powerAppsResourcesModule from "./localization/PowerAppsResources";

export { setTextDirection } from "@ax/office-resources-common";

const labelResolver = new LabelResolver();

/** The mechanism used to load labels. */
export const labelLoader = new LabelLoader(labelResolver);
export const powerAppsLabelLoader = new PowerAppsLabelLoader(labelResolver);

/** The object responsible for resolving labels. */
export const resources = new resourcesModule.GeneratedLabelResolver(labelResolver);
export const powerAppsResources = new powerAppsResourcesModule.GeneratedLabelResolver(labelResolver);
